module.exports = __webpack_public_path__ + "static/media/294624.70df8a08.png";